// extracted by mini-css-extract-plugin
module.exports = {"consentContainer":"video_consentContainer__9_AiX","text":"video_text__Tv4sz"};